import React from 'react'
import "./retail.scss"
import B2cProfits from './sections/b2cProfits'
import NumerousProcesses from './sections/numerousProcesses'
import ProductPerformanceList from './sections/productPerformanceList'
import Letsgo from "../connectors/letsgo"

function Retail() {
  return (
    <div className='container-retail'>
        <div className='section-b2c-profits'>
            <B2cProfits />
        </div>
        <div className="section-numerous-processes">
          <NumerousProcesses />
        </div>
        <div className="section-product-performance-list">
          <ProductPerformanceList />
        </div>
        <div className="section-lets-go">
        <Letsgo />
        </div>
    </div>
  )
}

export default Retail